import baseAPI from '@/api';
import { AxiosResponse } from 'axios';
import {
  AuthLoginRequestDto,
  AuthLoginResponseDto,
} from '@starsoft/common/dto';
import { AuthenticationResponseJSON } from '@simplewebauthn/browser';
import { LocalStorageKey } from '@/enums/localStorageKey';

export async function fetchPassKeyLogin(
  data: Pick<AuthLoginRequestDto, 'email'> & {
    payload: AuthenticationResponseJSON;
  },
): Promise<AuthLoginResponseDto> {
  const response: AxiosResponse<AuthLoginResponseDto> =
    await baseAPI.post<AuthLoginResponseDto>('/iam/passkey-login', data, {
      headers: {
        'x-device-id': localStorage.getItem(LocalStorageKey.UserUUID),
      },
    });
  return response.data;
}
